import { useContext, useState } from 'react'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { ReleaseNoteForm } from '../../../presentation-components/super-admin/super-admin-release-note-form'
import { IPostReleaseNote } from '../../../../shared/services/release-notes/release-notes-model'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import { useNavigate } from 'react-router-dom'
import ReleaseNotesService from '../../../../shared/services/release-notes/release-notes-service'
import moment from 'moment'

export const SuperAdminAddReleaseNotePage = () => {
  const navigate = useNavigate()
  //Services
  const releaseNotesService = new ReleaseNotesService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string | undefined>('')
  const [errorCode, setErrorCode] = useState<number>()
  const [newReleaseNote, setNewReleaseNote] = useState<IPostReleaseNote>({
    title: '',
    description: '',
    status: 'Feature',
    releasedDate: moment().format('YYYY-MM-DD'),
    released: false,
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)

  //Component Event Handlers
  const submitHandler = async (payload: { values: IPostReleaseNote, files: File[], removedResourceIds?: string[] }) => {
    if (!isFormSubmitting) {
      setIsFormSubmitting(true)
      const form = new FormData();
      if (payload.files && payload.files.length > 0) {
        for (let i = 0; i < payload.files.length; i++) {
          form.append('files', payload.files[i]);
        }
      }
      form.append('releaseNote', JSON.stringify(payload.values));
      releaseNotesService.create(form)
        .then(response => {
          setIsFormSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
          navigate(`/super-admin/release-notes/${response.id}`)
        })
        .catch(err => {
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
          console.log(err)
          setIsFormSubmitting(false)
        })
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Add Release Note'
        includeBackButton={true}
        backButtonLink={`/super-admin/release-notes`}
        backButtonText='Back to Release Notes'
      />
      <ReleaseNoteForm
        newReleaseNote={newReleaseNote}
        submitHandler={submitHandler}
        isSubmitting={isFormSubmitting}
        errorMessage={errorMessage}
        errorCode={errorCode}
      />
    </PageOuterContainer >
  )
}